import {reactive, computed, onMounted, onUnmounted} from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCaretDown)
library.add(faCaretUp)

export default {
  components: { FontAwesomeIcon },
  name: 'FormSelectStateCountryComponent',
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select an option',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup(props) {

    const state = reactive({
      options: props.options,
      disabled: props.disabled,
      selected: {},
      optionsShown: false,
      style: computed( () => {
        if (props.disabled) {
          return 'disabled';
        }
        if (state.optionsShown) {
          return 'open';
        }
        if (state.selected && state.selected.id) {
          return 'populated';
        }

        return '';
      }),
      unique: Math.random().toString(36).substring(2, 7),
    });

    if (props.value) {
      state.selected = props.value;
    }

    const listener = (event) => {
      let string = event.target.getAttribute('id');

      if ( string && string.includes(state.unique) ) {
        return
      }

      state.optionsShown = false;
    }

    onMounted(() => {
      window.addEventListener('click', listener, false);
    })

    onUnmounted(() => {
      window.removeEventListener('click', listener, false);
    })

    return { state };
  },
  methods: {
    select(option) {
      this.$emit('selected', option);
      this.state.selected = option;
      this.state.optionsShown = false;
    },
    click(event) {
      if (!this.state.disabled) {
        this.state.optionsShown = !this.state.optionsShown;
      }
    }
  },
};
